import appManager from '@app/appManager';
import { webphoneAppEvents } from '../constants/events';
import { phoneState } from '../state';

/**
 * Forwards `webphone:network-test-progress` to the app event bus so UserStatusModule
 * can set the agent unavailable for the duration of the network test.
 */
const handleNetworkTestProgress = (): void => {
  phoneState.networkTestInProgress = true;
  appManager.events.emit(webphoneAppEvents.networkTestProgress);
};

export default handleNetworkTestProgress;
